import addbutton from './addButtonIcon.svg'
import ExtentionImage from './ExtensionIcon.svg'

export const addShedRuminTechIcon = addbutton
export const ExtensionIcon = ExtentionImage
